<template>
  <main role="main" class="inner cover cover-container">
    <div class="force_center_align">
      <h1 class="cover-heading usefont">
        Conception, installation, intégration.
      </h1>
      <p class="lead">
        Faites confiance à notre équipe et nos plus de 20 ans d'expérience dans
        le milieu pour vos travaux de menuiserie Aluminium, Acier et PVC ainsi
        que pour la mise en place d'élements domotiques.
      </p>
      <p class="lead">
        <router-link to="/about" class="btn btn-lg btn-secondary"
          >En savoir plus !
        </router-link>
      </p>
    </div>
    <div class="spacer"></div>
    <div class="force_bottom_align">
      <h1 class="cover-heading usefont">Nos partenaires...</h1>
      <div class="container">
        <div class="flex-row">
          <div>
            <img
              class="image_part img-responsive"
              src="/images/Logo_PARTENAIRE_PROFERM.png"
              alt="ProfermPart"
            />
          </div>
          <div>
            <img
              class="image_part img-responsive"
              src="/images/Logo_PARTENAIRE_CAME.png"
              alt="CAMEPart"
            />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "Home",
  metaInfo: {
    title: "Accueil",
    titleTemplate: "%s | LEFLOCH Métal Concept",
  },
};
</script>
<style lang="css">
.image_part {
  max-width: 45%;
}

.spacer {
  height: 100px;
}

.flex-row {
  width: 70%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
}

.flex-row > div {
  flex: 1;
}
.flex-row > div > img {
  width: 100%;
  min-width: 250px;
}

.force_center_align {
  justify-content: center;
}
</style>